export default __webpack_public_path__ + "static/media/image3.374b5d08.jpg";